import React from 'react';
import loadable from '@loadable/component';
import { Route, Routes } from 'react-router-dom';
import QuestionRoute from './QuestionRoute';
import LoadingIndicator from 'components/shared/LoadingIndicator';

const InternPayment = loadable(() => import('components/candidate/intern-sub-screens/InternPayment'), { fallback: <LoadingIndicator /> });
const Account = loadable(() => import('components/account/Account'), { fallback: <LoadingIndicator /> });
const AccountDetail = loadable(() => import('components/account/AccountDetails'), { fallback: <LoadingIndicator /> });
const ApplicantList = loadable(() => import('components/applicant/ApplicantList'), { fallback: <LoadingIndicator /> });
const AddApplicant = loadable(() => import('components/applicant/modal/AddApplicant'), { fallback: <LoadingIndicator /> });
const IntervieweeDetail = loadable(() => import('components/candidate/interviewee-sub-screens/IntervieweeDetail'), { fallback: <LoadingIndicator /> });
const InterviewList = loadable(() => import('components/candidate/Interviewee'), { fallback: <LoadingIndicator /> });
const InternCandidate = loadable(() => import('components/candidate/InternCandidate'), { fallback: <LoadingIndicator /> });
const Project = loadable(() => import('components/candidate/Project'), { fallback: <LoadingIndicator /> });
const AddCandidateForm = loadable(() => import('components/candidate/modal/AddCandidateForm'), { fallback: <LoadingIndicator /> });


const AccountRoute: React.FC = () => {
    return (
        <div>
            <Routes>
                <Route path='/account' element={<Account />} />
                <Route path='/account/account-detail' element={<AccountDetail />} />
                <Route path='/applicant' element={<ApplicantList />} />
                <Route path='/applicant/add-applicant' element={<AddApplicant />} />
                <Route path="/candidate/internship-detail" element={<InternPayment />} />
                <Route path="/candidate/interviewee-candidate-detail" element={<IntervieweeDetail />} />
                <Route path="/candidate/interviewee" element={<InterviewList />} />
                <Route path="/candidate/internship" element={<InternCandidate />} />
                <Route path="/candidate/project" element={<Project />} />
                <Route path="/candidate/add-interviewee-candidate" element={<AddCandidateForm />} />
                <Route path="/candidate/add-internship-candidate" element={<AddCandidateForm />} />
                <Route path="/candidate/add-project-candidate" element={<AddCandidateForm />} />
                <Route path='*' element={<QuestionRoute />} />
            </Routes>
        </div>
    )
}

export default AccountRoute;